import { actions } from './currency/actions'
import { getters } from './currency/getters'
import { state } from './currency/state'
import { mutations } from './currency/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
